// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawer {
    width: 240px;
    flex-shrink: 0;
  }
  
  .drawerPaper {
    width: 240px;
    background-color: #1B285E;
    color: white;
  }
  
  .drawerHeader {
    display: flex;
    align-items: center;
    padding: 0 8px;
    justify-content: flex-end;
  }
  
  .listItem {
    color: white;
  }
  
  .listItem:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C","sourcesContent":[".drawer {\n    width: 240px;\n    flex-shrink: 0;\n  }\n  \n  .drawerPaper {\n    width: 240px;\n    background-color: #1B285E;\n    color: white;\n  }\n  \n  .drawerHeader {\n    display: flex;\n    align-items: center;\n    padding: 0 8px;\n    justify-content: flex-end;\n  }\n  \n  .listItem {\n    color: white;\n  }\n  \n  .listItem:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
